import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTileView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.02778 0.833333C0.919748 0.833333 0.833333 0.919748 0.833333 1.02778L0.833333 3.47222C0.833333 3.58025 0.919748 3.66667 1.02778 3.66667L3.47222 3.66667C3.58025 3.66667 3.66667 3.58025 3.66667 3.47222L3.66667 1.02778C3.66667 0.919748 3.58025 0.833333 3.47222 0.833333L1.02778 0.833333ZM0 1.02778C0 0.459511 0.459511 0 1.02778 0L3.47222 0C4.04049 0 4.5 0.459511 4.5 1.02778V3.47222C4.5 4.04049 4.04049 4.5 3.47222 4.5H1.02778C0.459511 4.5 0 4.04049 0 3.47222L0 1.02778Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.02778 6.33339C0.919748 6.33339 0.833333 6.41981 0.833333 6.52784L0.833333 8.97228C0.833333 9.08031 0.919748 9.16673 1.02778 9.16673H3.47222C3.58025 9.16673 3.66667 9.08031 3.66667 8.97228L3.66667 6.52784C3.66667 6.41981 3.58025 6.33339 3.47222 6.33339H1.02778ZM0 6.52784C0 5.95957 0.459511 5.50006 1.02778 5.50006H3.47222C4.04049 5.50006 4.5 5.95957 4.5 6.52784V8.97228C4.5 9.54055 4.04049 10.0001 3.47222 10.0001H1.02778C0.459511 10.0001 0 9.54055 0 8.97228L0 6.52784Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.52778 0.833333C6.41975 0.833333 6.33333 0.919748 6.33333 1.02778V3.47222C6.33333 3.58025 6.41975 3.66667 6.52778 3.66667L8.97222 3.66667C9.08025 3.66667 9.16667 3.58025 9.16667 3.47222V1.02778C9.16667 0.919748 9.08025 0.833333 8.97222 0.833333L6.52778 0.833333ZM5.5 1.02778C5.5 0.459511 5.95951 0 6.52778 0L8.97222 0C9.54049 0 10 0.459511 10 1.02778V3.47222C10 4.04049 9.54049 4.5 8.97222 4.5H6.52778C5.95951 4.5 5.5 4.04049 5.5 3.47222V1.02778Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.52778 6.33339C6.41975 6.33339 6.33333 6.41981 6.33333 6.52784V8.97228C6.33333 9.08031 6.41975 9.16673 6.52778 9.16673H8.97222C9.08025 9.16673 9.16667 9.08031 9.16667 8.97228V6.52784C9.16667 6.41981 9.08025 6.33339 8.97222 6.33339H6.52778ZM5.5 6.52784C5.5 5.95957 5.95951 5.50006 6.52778 5.50006H8.97222C9.54049 5.50006 10 5.95957 10 6.52784V8.97228C10 9.54055 9.54049 10.0001 8.97222 10.0001H6.52778C5.95951 10.0001 5.5 9.54055 5.5 8.97228V6.52784Z",
			fill: "currentColor"
		})
	]
});
export default SvgTileView;
